import { useQuery } from "@tanstack/react-query";
import { getMyKybRequests } from "../../services/kybService";
import type { AccountRequestLike } from "../../utils/businessAccountRequestDisplay";

export const myBusinessAccountRequestsQueryKey = [
  "myBusinessAccountRequests",
] as const;

export function useMyBusinessAccountRequests() {
  return useQuery({
    queryKey: myBusinessAccountRequestsQueryKey,
    queryFn: async () => {
      const result = await getMyKybRequests();
      const raw = result?.data?.requests;
      return (Array.isArray(raw) ? raw : []) as AccountRequestLike[];
    },
    staleTime: 60_000,
  });
}
